import { useDispatch } from "react-redux";

import { HeartRegularV6 } from "@shared/v2/Icomoon";
import format from "@shared/formatters";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import PipedElements from "../PipedElements";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";
import Thumbnail from "./shared/Thumbnail";

const FavPropertyActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={HeartRegularV6}>
            Saved Listing
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={STYLES.contentContainer2}>
        <div className={`${STYLES.contentContainer} tw-text-14d`}>
          <DataField label="Address" data={activity.data?.propertyStreetAddress} />
          <PipedElements containerClassName="tw-text-14d">
            <DataField label="Price" data={activity.data?.propertyPrice} />
            <DataField label="Bed" data={activity.data?.beds} />
            <DataField label="Bath" data={activity.data?.baths} />
          </PipedElements>
          <ActivityBtns
            callHandlr={() => {
              if (activity.data?.personUuid) {
                dispatch(
                  setCallParams({
                    leadUuids: [activity.data?.personUuid],
                    callSource: "Favorite Property Activity",
                  }),
                );
              }
            }}
            containerClassName="!tw-mt-8px"
          />
        </div>
        {activity.imageUrl && <Thumbnail src={activity.imageUrl} />}
      </div>
    </ActivityContainer>
  );
};

export default FavPropertyActivity;

FavPropertyActivity.propTypes = {
  ...activityCommonPropTypes,
};

FavPropertyActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
